import { createProfessionalExporter } from '../../../utils/professionalExport';

export function createPanelUserExporter({ title, slug, brand }) {
  const headers = ['Name', 'Email', 'Phone', 'Status', 'Joined', 'Last Login'];

  return createProfessionalExporter({
    title,
    headers,
    slug,
    brand,
    getRows: (list) =>
      list.map((user) => [
        user.name,
        user.email,
        user.phone,
        user.status.charAt(0).toUpperCase() + user.status.slice(1),
        user.joinedDate,
        user.lastLogin || '—',
      ]),
    getSummary: (list) => [
      `Total users: ${list.length}`,
      `Active: ${list.filter((u) => u.status === 'active').length}`,
    ],
  });
}
